var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psp_logo"},[_c('img',{attrs:{"src":"/assets/media/psp/mellat.png","width":"45","height":"55"}})])
}]

export { render, staticRenderFns }